import ReactSelect from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { Manager, Reference, Popper } from 'react-popper'

import { colors, sizes, zIndexes } from '../../variables.style'

export const ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
}

export function Select ({ size = 'large', label, width, orientation = ORIENTATION.VERTICAL, isCreatable = false, message, onOpen = () => {}, onClose = () => {}, labelClass, ...props }) {
  // React-Select component uses Emotion to style. This is not JSS.
  // https://react-select.com/styles
  const styles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? colors.brandAccent : 'white',

      '&:active': {
        backgroundColor: 'white'
      },

      '&:hover': {
        cursor: 'pointer'
      }
    }),
    container: (provided) => ({
      ...provided,
      ...(width ? { width } : {})
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: size === 'medium' ? sizes.buttonHeight : sizes.textInputHeight,
      borderColor: state.menuIsOpen ? colors.brandAccent : colors.borderGray,
      boxShadow: 'none',

      '&:hover': {
        borderColor: colors.brandAccent,
        boxShadow: 'none'
      }
    }),
    input: (provided) => ({
      ...provided,
      margin: 1
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      marginTop: 0,
      marginBottom: 0
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 5
    }),
    clearIndicator: (provided) => ({
      ...provided,
      cursor: 'pointer'
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: zIndexes.dropdownMenu
    })
  }

  function buildSelect () {
    return (
      <Manager>
        <Reference>
          {({ ref }) => (
            <div ref={ref}>
              {isCreatable
                ? <CreatableSelect isClearable styles={styles} {...props}/>
                // isSearchable breaks enter animations (https://github.com/JedWatson/react-select/issues/165)
                // Example of the issue: https://codesandbox.io/s/affectionate-rhodes-qir59
                : <ReactSelect isSearchable={false} styles={styles} onMenuOpen={onOpen} onMenuClose={onClose} {...props}></ReactSelect>
              }
            </div>
          )}
        </Reference>
        {message &&
          <Popper placement="top-start" positionFixed={true}>
            {({ ref, style, placement, arrowProps }) => (
              <div ref={ref} style={{ ...style, zIndex: zIndexes.inputMessageTooltip }} data-placement={placement} className={`tooltip-content ${message.type}-message`}>
                <div>{message.message}</div>
                <div ref={arrowProps.ref} className="tooltip-tip" />
              </div>
            )}
          </Popper>
        }
      </Manager>
    )
  }

  return (
    orientation === ORIENTATION.VERTICAL
      ? (
        <label className={labelClass ? `${labelClass} form-element-select` : 'form-element-select'}>
          {label && <div className={(size === 'medium') ? 'form-element-label-medium' : 'form-element-label'}>{label}</div>}
          {buildSelect()}
        </label>
      )
      : (
        <label className={labelClass ? `${labelClass} form-element-select form-element-wrapper-horizontal` : 'form-element-select form-element-wrapper-horizontal'}>
          {label && <div className="form-element-label-horizontal">{label}</div>}
          <div className="form-element-horizontal">
            {buildSelect()}
          </div>
        </label>
      )
  )
}
